// extracted by mini-css-extract-plugin
export default {"pageTabs":"NavBar_pageTabs__3joKO","pageTab":"NavBar_pageTab__ejfU+","pageTab_active":"NavBar_pageTab_active__dDDWa","pageTab_inactive":"NavBar_pageTab_inactive__Fp1ZI"};